import listActions from 'src/modules/escalation/list/escalationListActions';
import EscalationService from 'src/modules/escalation/escalationService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ESCALATION_DESTROY';

const escalationDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: escalationDestroyActions.DESTROY_STARTED,
      });

      await EscalationService.destroyAll([id]);

      dispatch({
        type: escalationDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.escalation.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/escalation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: escalationDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: escalationDestroyActions.DESTROY_ALL_STARTED,
      });

      await EscalationService.destroyAll(ids);

      dispatch({
        type: escalationDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.escalation.destroyAll.success'),
      );

      getHistory().push('/escalation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: escalationDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default escalationDestroyActions;
